/**
 * A lista com o item de `de` levado para a posição `para`.
 *
 * O caso que motivou: dez linhas lançadas, a terceira esquecida. Inclui-se a
 * linha 11 e ela é levada à posição 3 — as de 3 a 10 descem uma casa. É a
 * ordem do array que vira `sort_order` ao salvar, então mover aqui é mover no
 * banco.
 *
 * Índice fora da lista, ou mover para o mesmo lugar, devolve a MESMA lista
 * (mesma referência): o React não re-renderiza e nada é marcado como alterado.
 */
export const moverLinha = (lista = [], de, para) => {
  const n = lista.length;
  if (!Number.isInteger(de) || !Number.isInteger(para)) return lista;
  if (de < 0 || de >= n || para < 0 || para >= n || de === para) return lista;
  const nova = lista.slice();
  const [item] = nova.splice(de, 1);
  nova.splice(para, 0, item);
  return nova;
};
